/* globals Toastify */

import Toastify, { Options } from 'toastify-js';
import { isDev } from './utils/is-dev.fn';

const backgrounds = {
  green: 'linear-gradient(to right, #00b09b, #96c93d)',
  red: 'linear-gradient(to right, #b00000, #c93d7e)',
  yellow: 'linear-gradient(to right, #ffa35f, #ffc371)',
  blue: 'linear-gradient(to right, #5477f5, #73a5ff)',
};

const toast = (background = '') => {
  return (text: string, opts: Options = {}) => {
    const options: Options = {
      text,
      duration: 4000,
      gravity: 'bottom',
      position: 'center',
      style: {
        transform: 'none',
        background,
      },
      stopOnFocus: true,
      className: 'heic-toast',
      close: true,
      ...opts,
    };

    if (isDev()) {
      console.info('Toast', options);
    }

    Toastify(options).showToast();

    const toast = document.querySelector<HTMLDivElement>('.heic-toast');

    if (toast !== null) {
      const closeBtn = toast.querySelector('.toast-close');
      const onClose = () => {
        toast.classList.remove('show');
        closeBtn?.removeEventListener('click', onClose);
      };
      closeBtn?.addEventListener('click', onClose);

      toast.classList.remove('on');
      toast.style.transform = '';
      toast.style.bottom = '';
      toast.style.visibility = 'visible';

      setTimeout(() => toast.classList.add('show'), 0);
    }
  };
};

export const toastLog = toast(backgrounds.green);
export const toastError = toast(backgrounds.red);
export const toastWarn = toast(backgrounds.yellow);
export const toastInfo = toast(backgrounds.blue);
